export function formatTemperature(value) {
  return Number.isFinite(value) ? `${Number(value).toFixed(1)}°C` : "No reading";
}

export function formatRelativeTime(iso, now = Date.now()) {
  if (!iso) return "Never";
  const difference = Math.max(0, now - new Date(iso).getTime());
  const seconds = Math.floor(difference / 1000);
  if (seconds < 60) return `${seconds} sec ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  return new Intl.DateTimeFormat("en-IN", { day: "numeric", month: "short" }).format(new Date(iso));
}

export function formatLimit(device) {
  const maximum = Number(device.maximum_temperature_c);
  const minimum = device.minimum_temperature_c === null || device.minimum_temperature_c === "" ? null : Number(device.minimum_temperature_c);
  if (Number.isFinite(minimum)) return `Configured range ${minimum.toFixed(0)}°C to ${maximum.toFixed(0)}°C`;
  return `Configured upper limit ${maximum.toFixed(0)}°C`;
}

export function formatWifiStrength(value) {
  if (!Number.isFinite(value)) return { value: "Unknown", label: "Not reported", state: "unknown" };
  if (value >= -55) return { value: `${value} dBm`, label: "Strong", state: "strong" };
  if (value >= -70) return { value: `${value} dBm`, label: "Good", state: "good" };
  return { value: `${value} dBm`, label: "Weak", state: "weak" };
}

export function connectionLabel(path) {
  return {
    direct_wifi: "Direct Wi-Fi",
    cellular: "Cellular SIM",
    esp_now_relay: "Guardian Link",
    local_storage: "Local storage",
  }[path] ?? "Unknown";
}
